/* eslint-disable no-unused-vars */
/* eslint-disable n/no-callback-literal */
import React from "react";
import _ from "lodash";
import {
  Form,
  Input,
  Select,
  InputNumber,
  DatePicker,
  TimePicker,
  Switch,
  Cascader,
  Radio,
  Checkbox,
  TreeSelect
} from "@tinper/next-ui";
import {
  FileUpload,
  ImageUpload,
  InputMap,
  RichEditor,
  ButtonGroup
} from "./extends/index";
// import { RefTreeWithInput } from "../../RefTree/src";
// import { RefMultipleTableWithInput } from "../../RefTable/src";
// import { RefTreeTableWithInput } from "../../RefTreeTable/src";
import { DataFormContext } from "./DataFormContext";
// import EditableCell from '../../../common/EditableCell';
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;

// 已支持的输入类型
const InputType = {
  input: "input", // 文本框
  textarea: "textarea", // 多行文本域
  search: "search", // 搜索框
  password: "password", // 密码框
  inputNumberGroup: "inputNumberGroup", // 数字框组
  date: "date", // 日期框
  time: "time", // 时间框
  rangepicker: "rangepicker", // 日期范围选择器
  number: "number", // 数字框
  switch: "switch", // 开关
  select: "select", // 下拉选择
  cascader: "cascader", // 级联下拉
  radiogroup: "radiogroup", // 单选框
  checkboxgroup: "checkboxgroup", // 多选框
  fileupload: "fileupload", // 文件上传
  imageupload: "imageupload", // 图片上传
  inputmap: "inputmap", // 地图选址
  richeditor: "richeditor", // 富文本编辑
  buttongroup: "buttongroup", // 按钮组
  treeselect: "treeselect", // 树形下拉
  formlist: "formlist", // 树形下拉
  reftree: "reftree", // 树参照框
  reftable: "reftable", // 表参照框
  reftabletree: "reftabletree", // 树表参照框
  custom: "custom" // 自定义
  // enumselect:'enumselect',//自定义档案枚举下拉
  // currency:'currency',//金额框
  // attachmgrw:'attachmgrw',//附件管理
  // plaintext:'plaintext',//纯文本
  // autoselect:'autoselect', //自动匹配
  // inputbutton:'inputbutton' //文本按钮框
};

// 解决切换组件类型，表单报错问题
class InputItem extends React.Component {
  static contextType = DataFormContext;
  render () {
    const { children } = this.props;
    const inputProps = Object.assign({}, this.props);
    const { formValues } = this.context;
    const { controlled } = (children && children.props) || {};
    const { setFieldsValue, getFieldValue } = children.props.form || {};
    const value = formValues && formValues[children.props.name];
    if (controlled) {
      inputProps.value = Array.isArray(value) ? [...value] : value;
      children.props.value = inputProps.value;
      const changedValue = getFieldValue && getFieldValue(children.props.name);
      if (typeof changedValue === "object") {
        if (JSON.stringify(changedValue) !== JSON.stringify(value)) {
          setFieldsValue && setFieldsValue({ [children.props.name]: value });
        }
      } else {
        if (changedValue !== value && !Number.isNaN(value)) {
          setFieldsValue && setFieldsValue({ [children.props.name]: value });
        }
      }
    }
    // !inputProps.onChange && (inputProps.onChange = (val) => {
    //   console.log('onChange', this.props)
    //   this.props.value = value;
    //   this.props.onChange && this.props.onChange(value);
    // });
    delete inputProps.children;
    return React.cloneElement(children, inputProps);
  }
}
// 处理校验规则的属性
function getVerifyProps (props, state) {
  const getFieldProps =
    props.form && props.form.getFieldInstance && props.form.getFieldInstance;
  const passProps = {}; // 只有在外部有Form的情况下才提供校验
  const options = {};
  // TODO: 处理传入的form拓展属性和getFieldProps
  if (getFieldProps) {
    let rules = []; // 验证规则
    if (props.required) {
      // 必填验证
      let requireRule = {
        required: props.required,
        message: `${props.label || props.name}为必填项`
      };
      if (props.inputType === InputType.number) {
        requireRule = Object.assign(requireRule, { type: "number" });
      } else if (props.inputType === InputType.switch) {
        requireRule = Object.assign(requireRule, { type: "boolean" });
      } else if (props.inputType === InputType.cascader) {
        requireRule = Object.assign(requireRule, { type: "array" });
      } else if (props.inputType === InputType.date) {
        if (props.picker === "year") {
          // 年份
          requireRule = Object.assign(requireRule, { type: "number" });
        } else {
          // 日期
          requireRule = Object.assign(requireRule, { type: "date" });
        }
      } else if (props.inputType === InputType.rangepicker) {
        const validator = function (rule, value, callback) {
          if (value === undefined || value === null) {
            callback(new Error(rule.message));
          } else if (
            Array.isArray(value) &&
            _.isNull(value[0]) &&
            _.isNull(value[1])
          ) {
            callback(new Error(rule.message));
          } else {
            callback();
          }
        };
        requireRule = Object.assign(requireRule, { validator });
      } else if (props.inputType === InputType.inputmap) {
        // 地图选址对象
        requireRule = Object.assign(requireRule, { type: "object" });
      } else if (props.inputType === InputType.select) {
        let type = "string";
        if (props.multiple) {
          type = "array";
        }
        // select组件valueType等于object的时候，点清除后提交验证问题。（点清除把值设置成了{}）
        const validator = function (rule, value, callback) {
          // if (!_.isPlainObject(value)) {
          //   callback(new Error(rule.message));
          // } else
          if (value === undefined || value === null || value === "") {
            callback(new Error(rule.message));
          } else if (Array.isArray(value) && Object.keys(value).length === 0) {
            callback(new Error(rule.message));
          } else {
            callback();
          }
        };
        requireRule = Object.assign(requireRule, { type });
        if (!props.multiple) {
          requireRule = Object.assign(requireRule, { validator });
        }
      } else if (props.inputType === InputType.checkboxgroup) {
        requireRule = Object.assign(requireRule, { type: "array" });
      } else if (props.inputType === InputType.inputNumberGroup) {
        const validator = function (_rule, value, callback) {
          const { min, max } = _rule;
          if (value[0] === undefined || value[0] === null || value[0] === "") {
            callback(new Error(`最小值为必填项`));
          }
          if (value[1] === undefined || value[1] === null || value[1] === "") {
            callback(new Error(`最大值为必填项`));
          }
          if (value[0] < min) {
            callback(`最小值不小于${min}`);
          } else if (value[1] && value[1] > max) {
            callback(`最大值不大于${max}`);
          } else if (value[0] && value[1] && value[1] < value[0]) {
            callback("第二个值必须大于等于第一个值");
          } else {
            callback();
          }
        };
        state.rules.forEach((rule) => {
          if (rule.min !== undefined || rule.max !== undefined) {
            rule = Object.assign(rule, { validator });
          }
        });
      }
      rules.push(requireRule);
    }
    // 正则验证
    if (props.pattern) {
      try {
        rules.push({
          pattern: new RegExp(props.pattern),
          message: props.patternMsg
        });
      } catch (error) {
        console.error("不是一个有效的正则表达式[" + props.pattern + "]", error);
      }
    }
    if (Array.isArray(state.rules) && state.rules.length) {
      rules = rules.concat(state.rules);
    }
    if (props.defaultValue !== undefined) {
      // 设置默认值
      options.initialValue = props.defaultValue;
    }
    if (props.value !== undefined) {
      // 设置默认值
      options.initialValue = props.value;
    }
    if (rules.length) {
      options.rules = rules;
    }
    if (props.inputType === InputType.switch) {
      // Switch通过获取checked属性值作为value
      options.valuePropName = "checked";
      options.initialValue = props.defaultValue || false;
    }
    if (typeof props.onChange === "function") {
      options.onChange = props.onChange;
    }
    // passProps = getFieldProps(props.name, options);
    if (props.size) {
      // antd.form组件FormItem.jsx,176行,form子元素没有设置size的情况下默认赋予size: 'large'属性
      passProps.size = props.size; // 传递实际元素的size属性给本页14行的InputItem(form子元素)
    }
  }
  return { ...passProps, ...options };
}

// 场景1示例： 公共的渲染逻辑
function renderItemComponent (InputComponent, props, state) {
  // TODO属性合并
  const { children, onChange, ...oProps } = props;
  const passProps = { onChange };
  return (
    <InputItem {...passProps} >
      <InputComponent {...props}/>
    </InputItem>
  );
}

// 场景2示例： 特定的渲染逻辑
function renderInput (props, state, isInputButton = false, isTextarea = false) {
  const { children, ...inputProps } = props;
  if (isTextarea) {
    inputProps.type = "textarea";
  }
  const passProps = {};
  const buttonProps = true;
  const form = inputProps.form;
  if (isInputButton) {
    return (
      <InputItem {...passProps}>
        <Input.Search {...inputProps} />
      </InputItem>
    );
  } else {
    return (
      <InputItem {...passProps}>
        <Input {...inputProps} />
      </InputItem>
    );
  }
}
// 场景3示例： 自定义渲染逻辑
function renderCustomComponent (props, state) {
  let { children, name, controlled, formValues, ...inputProps } = props;
  const { getFieldValue, setFieldsValue } = props.form || {};
  // children要有一个根结点
  try {
    if (!React.isValidElement(children)) {
      // 如果children是数组，取第一个元素
      if (React.Children.count(children) === 1) {
        children = React.Children.toArray(children)[0];
        return React.cloneElement(children, { ...inputProps });
      }
      console.warn("DataForm.Item is not a valid React element");
      return null;
    }
    const getControlled = () => {
      let value = getFieldValue && getFieldValue(name);
      if (controlled) {
        value = formValues && formValues[name];
      }
      setFieldsValue?.({ [name]: value });
      return {
        ...inputProps,
        value,
        onChange: (val) => {
          setFieldsValue?.({ [name]: controlled ? value : val });
        }
      };
    };
    return React.cloneElement(children, { ...getControlled() });
  } catch (error) {
    console.log(error);
    return null;
  }
}

class DataFormItem extends React.Component {
  static contextType = DataFormContext;
  constructor (props) {
    super(props);
    this.state = {
      rules: this.props.rules || []
    };
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.rules && !_.isEqual(nextProps.rules, this.state.rules)) {
      this.setState({ rules: nextProps.rules });
    }
  }

  // 动态设置验证规则
  setRules (rules) {
    this.setState({ rules });
  }

  // 渲染表单项
  _renderFormItem (inputType, originProps) {
    const props = originProps;
    const state = this.state;
    switch (inputType) {
    case InputType.input: {
      return renderInput(props, state);
    }
    case InputType.textarea: {
      return renderInput(props, state, false, true);
    }
    case InputType.search: {
      return renderInput(props, state, true);
    }
    case InputType.password: {
      props.type = "password";
      return renderInput(props, state);
    }
    case InputType.inputNumberGroup: {
      return renderItemComponent(InputNumber.InputNumberGroup, props, state);
    }
    case InputType.select: {
      return renderItemComponent(Select, props, state);
    }
    case InputType.date: {
      return renderItemComponent(DatePicker, props, state);
    }
    case InputType.number: {
      return renderItemComponent(InputNumber, props, state);
    }
    case InputType.switch: {
      return renderItemComponent(Switch, props, state);
    }
    case InputType.cascader: {
      return renderItemComponent(Cascader, props, state);
    }
    case InputType.radiogroup: {
      return renderItemComponent(RadioGroup, props, state);
    }
    case InputType.checkboxgroup: {
      return renderItemComponent(CheckboxGroup, props, state);
    }
    case InputType.time: {
      return renderItemComponent(TimePicker, props, state);
    }
    case InputType.rangepicker: {
      return renderItemComponent(RangePicker, props, state);
    }
    case InputType.fileupload: {
      return renderItemComponent(FileUpload, props, state);
    }
    case InputType.imageupload: {
      return renderItemComponent(ImageUpload, props, state);
    }
    case InputType.richeditor: {
      return renderItemComponent(RichEditor, props, state);
    }
    case InputType.inputmap: {
      return renderItemComponent(InputMap, props, state);
    }
    case InputType.buttongroup: {
      return renderItemComponent(ButtonGroup, props, state);
    }
    case InputType.treeselect: {
      return renderItemComponent(TreeSelect, props, state);
    }
    case InputType.formlist: {
      props.children =
          props.children || props.renderCallback || (() => <></>);
      return renderItemComponent(Form.List, props, state);
    }
    // case InputType.reftree: {
    //   props.style = Object.assign({}, props.style, { width: "100%" });
    //   return renderItemComponent(RefTreeWithInput, props, state);
    // }
    // case InputType.reftable: {
    //   return renderItemComponent(RefMultipleTableWithInput, props, state);
    // }
    // case InputType.reftabletree: {
    //   return renderItemComponent(RefTreeTableWithInput, props, state);
    // }
    case InputType.custom: {
      return renderCustomComponent(props, state);
    }
    default:
      return null;
    }
  }

  _getFormItemCol (attr) {
    const {
      labelCol,
      formLabelCol,
      wrapperCol,
      formWrapperCol,
      labelColSacle = 1,
      layout,
      hasTooltip
    } = this.props;
    if (attr === "label") {
      if (labelCol) {
        // 自身的
        if (labelCol.span) {
          return { span: Math.floor(labelCol.span / labelColSacle) };
        }
        if (typeof labelCol === "number") {
          return { span: Math.floor(labelCol / labelColSacle) };
        }
        return labelCol;
      } else if (formLabelCol) {
        // form传下来的
        return { span: Math.floor(formLabelCol / labelColSacle) };
      } else {
        return {
          style: {
            width:
              layout === "vertical" ? "100%" : hasTooltip ? "100px" : "80px",
            flex: "0 0 auto",
            whiteSpace: "break-spaces"
          }
        };
        // return { span: Math.floor(8 / labelColSacle) }; // 都未定义的
      }
    } else if (attr === "wrapper") {
      if (wrapperCol) {
        if (wrapperCol.span) {
          return { span: 24 - Math.floor(wrapperCol.span * labelColSacle) };
        }
        if (typeof labelCol === "number") {
          return { span: 24 - Math.floor(wrapperCol * labelColSacle) };
        }
        return wrapperCol;
      } else if (formWrapperCol) {
        return { span: 24 - Math.floor(formWrapperCol * labelColSacle) };
      } else {
        return {
          style: {
            flex: "auto",
            width: layout === "vertical" ? "100%" : "auto"
          }
        };
        // return { span: 24 - Math.floor(8 / labelColSacle) };
      }
    }
  }

  render () {
    const { formValues } = this.context;
    const { inputType, className, ...originProps } = this.props;
    const passProps = getVerifyProps(this.props, this.state);
    return (
      <FormItem
        className={["as-dataForm-item", className].join(" ")}
        style={{
          flexWrap: "nowrap"
        }}
        {...originProps}
        labelCol={this._getFormItemCol("label")}
        wrapperCol={this._getFormItemCol("wrapper")}
        {...passProps}
      >
        {/* <EditableCell inputType={inputType} {...originProps} formValues={formValues}/> */}
        {this._renderFormItem(inputType, { formValues, ...originProps })}
      </FormItem>
    );
  }
}
DataFormItem.TagName = "DataFormItem";
DataFormItem.InputType = InputType;
export default DataFormItem;
